<template>
  <div class="chart-card">
    <h3 class="chart-title">SOP Completion Status</h3>
    <div class="chart-container">
      <canvas id="completionChart"></canvas>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["completed","in_progress","not_started"],
    mounted() {
      const instance = this;
      var scriptTag = document.createElement("script");
      scriptTag.src = "https://cdnjs.cloudflare.com/ajax/libs/Chart.js/3.9.1/chart.min.js";
      scriptTag.id = "chart";

      // Append to head
      document.getElementsByTagName('head')[0].appendChild(scriptTag);
      scriptTag.onload = function () {
        const completionCtx = document.getElementById('completionChart').getContext('2d');
        const completionChart = new Chart(completionCtx, {
          type: 'doughnut',
          data: {
            labels: ['Completed', 'In Progress', 'Not Started'],
            datasets: [{
              data: [instance.completed, instance.in_progress, instance.not_started],
              backgroundColor: [
                '#10b981', // green
                '#f59e0b', // amber
                '#ef4444'  // red
              ],
              borderColor: [
                '#fff',
                '#fff',
                '#fff'
              ],
              borderWidth: 2
            }]
          },
          options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'bottom'
              }
            },
            cutout: '70%'
          }
        });
      }
      
    }
  };
</script>

<style scoped>
  .chart-card {
    background: #ffffff;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05));
  }

  .chart-title {
    font-size: 18px;
    margin-bottom: 20px;
    font-weight: 700;
  }

  .chart-container {
    position: relative;
    height: 300px;
  }
</style>
